import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale';
export default function Empty(_ref) {
  var id = _ref.id,
      className = _ref.className,
      image = _ref.image,
      description = _ref.description,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classNames('jmtd-empty', className)
  }, image, description && /*#__PURE__*/React.createElement("div", {
    className: "jmtd-empty-description"
  }, description), children);
}
Empty.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.node,
  description: PropTypes.node,
  children: PropTypes.node
};
Empty.defaultProps = {
  id: null,
  className: '',
  image: /*#__PURE__*/React.createElement("div", {
    className: "jmtd-empty-img"
  }),
  description: /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    return getLocale(locale).common.noData;
  }),
  children: null
};